export default {
  root: {
    marginRight: 24,
    marginBottom: 18,
  },
};
